var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
var useLocalStoreState = function (store, storeKey, defaultValue) {
    var _a = __read(useState(store.get(storeKey, defaultValue)), 2), value = _a[0], setValue = _a[1];
    useEffect(function () {
        store.set(storeKey, value);
    }, [value]);
    return [value, setValue];
};
export { useLocalStoreState, };
//# sourceMappingURL=useLocalStoreState.js.map